export var AllViewQueryConfigurationConstants = [];
